import React, { Component } from "react";
import WorkItem from "./WorkItem";
import Image from "../../assets/img/work/png/dekocom.png";

class DekoCom extends Component {
  componentDidMount() {
    this.item.componentDidMount();
  }

  enterTransition = time => {
    this.item.enterTransition(time);
  };

  exitTransition = time => {
    this.item.exitTransition(time);
  };

  render = () => {
    return (
      <WorkItem
        ref={item => (this.item = item)}
        title="Deko"
        description={`Content management application with integrated backend products. Application reads frontend code and
        generates forms for data administration. The greatest challenge was to create a mechanism for
        automatically generated content management forms by programatically analysing Vue.js frontend
        components.
        Our part: requirements analysis, backend and frontend development, automated testing.`}
        image={Image}
        iconList={["react", "redux", "vue", "mongo", "node"]}
      />
    );
  };
}

export default DekoCom;



// WEBPACK FOOTER //
// ./src/components/Work/DekoCom.js